import { defineMessages } from 'react-intl';

const scope = 'cb.screens';

export default defineMessages({
  welcomeScreen: {
    id: `${scope}.welcomeScreenTitle`,
    defaultMessage: 'Welcome!',
  },
  createBtn: {
    id: `${scope}.createBtn`,
    defaultMessage: 'Create Account',
  },
  processingBtn: {
    id: 'signup.processing',
    defaultMessage: 'Processing...',
  },
  password: {
    id: `${scope}.password`,
    defaultMessage: 'Password',
  },
  email: {
    id: `${scope}.email`,
    defaultMessage: 'Email',
  },
  legalInformationTitle: {
    id: `${scope}.legalInformationTitle`,
    defaultMessage: 'Legal information',
  },
  firstName: {
    id: `${scope}.firstName`,
    defaultMessage: 'First Name',
  },
  lastName: {
    id: `${scope}.lastName`,
    defaultMessage: 'Last Name',
  },
  city: {
    id: `${scope}.city`,
    defaultMessage: 'City',
  },
  province: {
    id: `${scope}.province`,
    defaultMessage: 'Province',
  },
  privacyPolicyText: {
    id: `${scope}.privacyPolicyText`,
    defaultMessage: 'Privacy Policy',
  },
  termsOfServiceText: {
    id: `${scope}.termsOfServiceText`,
    defaultMessage: 'Terms of Service',
  },
  entityProvinces: {
    id: `${scope}.entityProvinces`,
    defaultMessage: 'provinces',
  },
  entityCities: {
    id: `${scope}.entityCities`,
    defaultMessage: 'cities',
  },
});
